import { fetcher } from '@commenda/utils';

import { TCreateBillingSkuParams } from './types';

export const createBillingSku = async (params: TCreateBillingSkuParams) => {
  const response = await fetcher('commenda-billing/catalog/skus', {
    method: 'POST',
    body: params,
  });

  return response;
};
